import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectWithNeighbors = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('with_neighbors')(jsonQuery),
);
